document.addEventListener('DOMContentLoaded', function() {
  // Create a wrapper for header and announcement bar if they both exist
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');
  let lastScrollY = window.scrollY;
  let scrollTimeout;
  
  // Create header-group wrapper
  if (header && announcementBar && !document.querySelector('.header-group')) {
    // Create the container
    const headerGroup = document.createElement('div');
    headerGroup.className = 'header-group';
    
    // Get parent elements
    const headerParent = header.parentNode;
    const announcementParent = announcementBar.parentNode;
    
    // Insert the wrapper before the header
    headerParent.insertBefore(headerGroup, header);
    
    // Move elements into the wrapper
    headerGroup.appendChild(announcementBar);
    headerGroup.appendChild(header);
  }
  
  const headerGroup = document.querySelector('.header-group');
  
  const updateHeights = () => {
    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;
    
    document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    
    // Calculate the proper padding-top for the main element
    const mainPaddingTop = headerGroup 
      ? headerGroup.offsetHeight 
      : (announcementBar ? headerHeight + announcementHeight : headerHeight);
    
    document.documentElement.style.setProperty('--header-padding', `${mainPaddingTop}px`);
  };
  
  updateHeights();
  window.addEventListener('resize', updateHeights);
  
  function controlHeader() {
    const currentScrollY = window.scrollY;
    
    // Add/remove scrolled class based on scroll position
    if (currentScrollY > 150) {
      if (headerGroup) {
        headerGroup.classList.add('scrolled');
      } else {
        header.classList.add('scrolled');
      }
    } else if (currentScrollY <= 0) {
      // Make sure to remove the class when at the top
      if (headerGroup) {
        headerGroup.classList.remove('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    } else if (currentScrollY < 150) {
      if (headerGroup) {
        headerGroup.classList.remove('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    
    // Don't hide header if a drawer is open
    if (!header.classList.contains('drawer-is-open')) {
      // Hide/show header and announcement bar together based on scroll direction
      if (currentScrollY > lastScrollY && currentScrollY > 80) {
        if (headerGroup) {
          headerGroup.classList.add('header-group--hidden');
        } else {
          header.classList.add('header--hidden');
          if (announcementBar) {
            announcementBar.classList.add('announcement--hidden');
          }
        }
      } else {
        if (headerGroup) {
          headerGroup.classList.remove('header-group--hidden');
        } else {
          header.classList.remove('header--hidden');
          if (announcementBar) {
            announcementBar.classList.remove('announcement--hidden');
          }
        }
      }
    } else {
      // Si un drawer está abierto, asegurarse de que el header y el announcement bar sean visibles
      if (headerGroup) {
        headerGroup.classList.remove('header-group--hidden');
      } else {
        header.classList.remove('header--hidden');
        if (announcementBar) {
          announcementBar.classList.remove('announcement--hidden');
        }
      }
    }
    
    lastScrollY = currentScrollY;

    // Clear previous timeout
    clearTimeout(scrollTimeout);
    
    // Set a new timeout to check when scrolling stops
    scrollTimeout = setTimeout(() => {
      // Verify position one last time when scrolling stops
      if (window.scrollY <= 0) {
        if (headerGroup) {
          headerGroup.classList.remove('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
      }
    }, 150); // 150ms after scrolling stops
  }
  
  // Use requestAnimationFrame to optimize performance
  let ticking = false;
  
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        controlHeader();
        ticking = false;
      });
      ticking = true;
    }
  });

  // Check initial position
  if (window.scrollY <= 0) {
    if (headerGroup) {
      headerGroup.classList.remove('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }

  // Mobile menu title buttons event listeners
  const titleButtons = document.querySelectorAll('.mobile-menu__title-button');
  
  titleButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      const toggle = this.querySelector('.mobile-menu__toggle');
      if (!toggle) return;
      
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      
      const submenu = this.closest('.mobile-menu__item').querySelector('.mobile-submenu');
      if (submenu) {
        submenu.style.maxHeight = !isExpanded ? `${submenu.scrollHeight}px` : '0';
      }
    });
  });

  // Observar cambios en la clase drawer-is-open del header
  const observerCallback = function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (header.classList.contains('drawer-is-open')) {
          // Cuando se añade drawer-is-open al header, asegurar que el header-group sea visible
          if (headerGroup) {
            headerGroup.classList.remove('header-group--hidden');
          }
        }
      }
    }
  };

  const observer = new MutationObserver(observerCallback);
  observer.observe(header, { attributes: true });
});
